import type { JSX } from 'react';
import i18n from '@app/i18n';
import { MatchingTrialStatus } from '@data/sdk/match';
import { AntdConfigProvider, AntdTag } from '@ui/components';
import {
  COLOR_BASE_600,
  COLOR_ERROR,
  COLOR_PRIMARY_500,
  COLOR_SUCCESS,
  COLOR_WARNING,
} from '@ui/constants';

export const createStatusTag = (status?: MatchingTrialStatus): JSX.Element | null => {
  switch (status) {
    case MatchingTrialStatus.Processing:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Tag: { defaultBg: `${COLOR_PRIMARY_500}19`, colorBorder: `${COLOR_PRIMARY_500}50` },
            },
          }}
        >
          <AntdTag className="text-base-900 " bordered>
            {i18n.t('admin:trial_status.processing')}
          </AntdTag>
        </AntdConfigProvider>
      );

    case MatchingTrialStatus.Active:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Tag: { defaultBg: `${COLOR_SUCCESS}19`, colorBorder: `${COLOR_SUCCESS}50` },
            },
          }}
        >
          <AntdTag className="text-base-900">{i18n.t('admin:trial_status.recruiting')}</AntdTag>
        </AntdConfigProvider>
      );

    case MatchingTrialStatus.Completed:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Tag: { defaultBg: `${COLOR_BASE_600}19`, colorBorder: `${COLOR_BASE_600}50` },
            },
          }}
        >
          <AntdTag color="default" className="text-base-600">
            {i18n.t('admin:trial_status.completed')}
          </AntdTag>
        </AntdConfigProvider>
      );

    case MatchingTrialStatus.Proposed:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Tag: { defaultBg: `${COLOR_WARNING}19`, colorBorder: `${COLOR_WARNING}50` },
            },
          }}
        >
          <AntdTag className="text-base-900">{i18n.t('admin:trial_status.proposed')}</AntdTag>
        </AntdConfigProvider>
      );

    case MatchingTrialStatus.Deleted:
      return (
        <AntdConfigProvider
          theme={{
            components: {
              Tag: { defaultBg: `${COLOR_ERROR}19`, colorBorder: `${COLOR_ERROR}50` },
            },
          }}
        >
          <AntdTag className="text-base-900">{i18n.t('admin:trial_status.deleted')}</AntdTag>
        </AntdConfigProvider>
      );

    default:
      return null;
  }
};
